import {
  currentUserRefreshToken,
  currentUserToken,
  getAPIBaseUrl,
} from "../utils/constants";
import { createApiClient } from "./createApiClient";

export default createApiClient({
  baseURL: getAPIBaseUrl(),
  getRefreshToken: currentUserRefreshToken,
  getToken: currentUserToken,
});
